/**
 * How an invoice line's description is DISPLAYED (Andrew, 02/10/2026): the trailing billing
 * detail goes on its own line —
 *   Little Test - Foundation 2 - Piano
 *   (5 weeks, start date 16/11/2026)
 * Display only: the stored description stays one line. Only a trailing "(N week…)" moves; any
 * other bracket an admin typed stays where it is. Render with `white-space: pre-line`.
 * Mirrors the backend's `services/invoice/lineDescription.ts` (the PDF).
 */
const TRAILING_WEEKS = /^(.*\S)\s+(\(\d+ weeks?\b[^()]*\))\s*$/s;

export function displayLineDescription(description: string): string {
  const match = TRAILING_WEEKS.exec(description);
  return match ? `${match[1]}\n${match[2]}` : description;
}
